export default {
  message: `Seuls les candidats intéressés par les postes que vous suivez sont affichés ici`,
  searchResultMsg: `Désolé, nous n'avons trouvé aucun résultat correspondant à cette recherche`,
  positionWiseSearch: `Filtrer un poste`,
};
